import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useCceModel } from "../cceModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useCceModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "信用证号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Datepicker,
            placeholder: "到证日期",
            fieldName: "confirmTime",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [
                { label: '已登记', value: 0 },
                { label: '已收汇', value: 1 }
            ]
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "信用证类型",
            fieldName: "creditType",
            options: getSelectedDictOne(DictCodeEnmu.EXPORT_CREDIT_TYPE)
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "外贸合同号",
            fieldName: "saleCode",
        },
        {
            type: SearchTypeEnum.Input,
            placeholder: "开证金额",
            fieldName: "amount",
        },
    ]

    return (
        <YhPageHeader
            title="信用证/信用证列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}